// Match the backend's context limits; discard old messages, never cut their text.
export const trimChatbotHistory = (history) => {
  const recent = []
  let characters = 0
  for (let i = history.length - 1; i >= 0 && recent.length < 20; i -= 1) {
    const message = history[i]
    const length = Array.from(message.content).length
    if (characters + length > 16000) break
    recent.unshift({ role: message.role, content: message.content })
    characters += length
  }
  return recent
}

export const chatbotLimitMessage = (error) => {
  const status = error.response?.status
  const code = error.response?.data?.error
  if (status === 413) {
    return 'O pedido é demasiado longo. Use até 4000 caracteres por mensagem ou comece uma nova conversa.'
  }
  if (status === 422) {
    return 'O pedido envolve demasiadas operações. Divida-o em pedidos menores.'
  }
  if (status !== 429 || code === 'quota_exceeded') return null
  if (code === 'chat_busy') {
    return 'Já existe um pedido em processamento para esta farmácia. Aguarde que termine e tente novamente.'
  }
  const seconds = Number(error.response?.headers?.['retry-after'])
  return Number.isInteger(seconds) && seconds > 0 && seconds <= 300
    ? `Foram enviados demasiados pedidos. Tente novamente dentro de ${seconds} segundos.`
    : 'Foram enviados demasiados pedidos. Aguarde um pouco e tente novamente.'
}
